export const dictionary = {
	doc: "Word document",
	docx: "Word document",
	email: "E-mail",
	pdf: "Pdf document",
	pptx: "Powerpoint document",
	ppt: "Powerpoint document",
	txt: "Text document",
	log: "Text document",
	xls: "Excel document",
	xlsx: "Excel document",
}
